import { render, staticRenderFns } from "./button-action.vue?vue&type=template&id=d80af122&scoped=true&"
import script from "./button-action.vue?vue&type=script&lang=js&"
export * from "./button-action.vue?vue&type=script&lang=js&"
import style0 from "./button-action.vue?vue&type=style&index=0&id=d80af122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80af122",
  null
  
)

export default component.exports